import { addBreadcrumb } from "@sentry/vue";

import { useFeatureFlagStore, FeatureFlagKeys } from "@/feature-flags";
import { endpoints, EndpointEnvVar } from "@/config/endpoints";

// Last resolved value per endpoint, so we breadcrumb only on change.
const lastResolved: Partial<Record<EndpointEnvVar, string>> = {};

/**
 * Resolve an endpoint base URL from the Flagsmith per-group override, falling
 * back to the static build-time value. The override JSON is keyed
 * by env-var name; only whitelisted endpoints are ever looked up.
 */
export function flagsmithEndpointResolver(name: EndpointEnvVar): string {
  const fallback = endpoints[name];

  try {
    const override = useFeatureFlagStore().getObjectValue(
      FeatureFlagKeys.EndpointsK8sOverride,
      {}
    ) as Record<string, string>;
    const resolved = override[name] || fallback;

    if (resolved !== fallback && lastResolved[name] !== resolved) {
      lastResolved[name] = resolved;
      addBreadcrumb({
        category: "endpoints",
        message: `cluster override applied for ${name}`,
        data: { name, resolved },
      });
    }

    return resolved;
  } catch {
    return fallback;
  }
}
